import React from "react";
import { useNavigate } from "react-router-dom";

import Table from "../../components/Table";

import TooltipTwyny from "../../components/tooltip";

const ListPaymentPlans = ({ payment, setHistoric }) => {
  const navigate = useNavigate();

  const columns = React.useMemo(
    () => [
      {
        Header: "Date de souscription",
        accessor: "created",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Nom du plan",
        accessor: "planName",
        Cell: ({ value }) => value || "N/A",
      },
      {
        Header: "Prix TTC",
        accessor: "ttc",
        Cell: ({ value }) => value || "N/A",
      },

      {
        Header: "Actions",
        Cell: ({ row }) => {
          const { download_url } = row.original;
          return (
            <div className="action-icons">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(
                    download_url + "?token=" + localStorage.getItem("token"),
                    "_blank"
                  );
                }}
                className="action-btn download"
              >
                <TooltipTwyny
                  children={<img src="/images/download.svg" alt="Download" />}
                  text="Télécharger la facture"
                  className="left100"
                />
              </button>
            </div>
          );
        },
      },
    ],
    [navigate]
  );

  const data = React.useMemo(() => {
    if (!payment || !Array.isArray(payment)) return [];

    return payment.map((transfer) => ({
      id: transfer.id,
      download_url: transfer?.download_url,
      created: transfer?.created,
      ttc: transfer?.total,
      planName: transfer?.plan?.name,
    }));
  }, [payment]);

  return (
    <>
      <div className=" d-flex justify-content-between">
        <h3>Historique des abonnements</h3>
        <button
          className="link-blue"
          onClick={() => {
            setHistoric([]);
          }}
        >
          Voir mon plan
        </button>
      </div>

      <div className="mt-24">
        <Table
          columns={columns}
          data={data}
        />
      </div>
    </>
  );
};

export default ListPaymentPlans;
